// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5803":"20751abf","7299":"20751abf","7798":"da82d7b9","9898":"4e473c97"}[chunkId] + ".chunk.css";
};